import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import {
  Card,
  Box,
  CardContent,
  Grid,
  Typography,
  Avatar,
  LinearProgress
} from '@mui/material';
import InsertChartIcon from '@mui/icons-material/InsertChartOutlined';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  progress: {
    marginTop: theme.spacing(3)
  }
}));

const TasksProgress = props => {
  const { className, orderDashboard, ...rest } = props;

  const classes = useStyles();
  console.log(parseFloat(orderDashboard.orderCount) / 10.0);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              TODAY ORDERS
            </Typography>
            <Typography variant="h3">{orderDashboard.orderCount}</Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <InsertChartIcon className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>


        <Box display="flex" alignItems="center">
          <Box width="100%" mr={1}>
            <LinearProgress
              className={classes.progress}
              value={orderDashboard.orderCount * 100 / 50}
              variant="determinate"
            />
          </Box>
          <Box minWidth={35}>
            <Typography variant="body2" color="textSecondary">50</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

TasksProgress.propTypes = {
  className: PropTypes.string
};

export default TasksProgress;
